export default __webpack_public_path__ + "static/media/map.17e33054.png";